export const economic_growth_development_employment = [
  {
    id: 1,
    name: 'Growth-for-Jobs-Strategy-2023-Cabinet-Approved',
    summary: 'shortsummary/Growth-for-Jobs-Strategy-2023-Cabinet-Approved.html',
    link: 'Growth-for-Jobs-Strategy-2023-Cabinet-Approved.pdf',
    audio_en: 'audio/en/Growth-for-Jobs-Strategy-2023-Cabinet-Approved_en.mp3',
    audio_af: 'audio/af/Growth-for-Jobs-Strategy-2023-Cabinet-Approved_af.mp3',
    audio_xh: 'audio/xh/Growth-for-Jobs-Strategy-2023-Cabinet-Approved_xh.mp3'
  },
  {
    id: 2,
    name: 'NLTF 2023-2038',
    summary: 'shortsummary/NLTF 2023-2038.html',
    link: 'NLTF 2023-2028.pdf',
    audio_en: 'audio/en/NLTF 2023-2028_en.mp3',
    audio_af: 'audio/af/NLTF 2023-2028_af.mp3',
    audio_xh: 'audio/xh/NLTF 2023-2028_xh.mp3'
  },
  {
    id: 3,
    name: 'NLTF',
    summary: 'shortsummary/NLTF.html',
    link: 'NLTF.pdf',
    audio_en: 'audio/en/NLTF_en.mp3',
    audio_af: 'audio/af/NLTF_af.mp3',
    audio_xh: 'audio/xh/NLTF_xh.mp3'
  }
];